import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=a0f26442&lang=scss&scoped=true"

import exportComponent from "/Users/CHSH/CHSH_H/CHSH_vue_v07/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0f26442"]])

export default __exports__